/** Static assets from `/public` (bundled; no external CDN). */
export const brandLogoUrl = `${import.meta.env.BASE_URL}logo.png`;
export const avatarPlaceholderUrl = `${import.meta.env.BASE_URL}avatar-placeholder.svg`;
